export default "__VITE_PUBLIC_ASSET__51a1e510__"